import { Component, OnDestroy } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { HamburgerMenuComponent, HamburgerMenuService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ICON_TYPE } from 'src/app/custom/icons/icon.model';


@Component({
  selector: 'app-custom-hamburguer-menu',
  templateUrl: './custom-hamburguer-menu.component.html',
  styleUrls: ['./custom-hamburguer-menu.component.scss'],
  standalone: false
})
export class CustomHamburguerMenuComponent extends HamburgerMenuComponent implements OnDestroy {
  iconTypes = ICON_TYPE;
  subscriptions = new Subscription();


  constructor(hamburgerMenuService: HamburgerMenuService,
              protected customHamburgerMenuService: HamburgerMenuService,
              protected winRef: WindowRef) {
    super(hamburgerMenuService);

    this.subscriptions.add(
      this.customHamburgerMenuService?.isExpanded
        .pipe(distinctUntilChanged())
        .subscribe((isExpanded) => {
          if (!isExpanded) {
            this.winRef.document.body.classList.remove('no-scroll');
          } else {
            this.winRef.document.body.classList.add('no-scroll');
          }
        })
    );
  }

  toggle(): void {
    this.customHamburgerMenuService.toggle();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.winRef.document.body.classList.remove('no-scroll');
  }
}
